import styled, { keyframes }  from 'styled-components';
const progressBar = keyframes`
  0% { left:0%;width: 25%; }
  50% { left:0%;width: 50%; }
  100% {left:0%;width: 100%}
`;

export default styled.div`
  height: 0.5rem;
  position: fixed;
  opacity: 1;
  background: #007eff;
  overflow: hidden;
  animation: ${progressBar}  1.5s ease-in-out;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  z-index: 9999999999999;
  transition: 1s opacity linear;
  transition-delay: 500ms;
  left: 0;
  width: 0;
  top: 0;
  display: none;

  &.Progressbar-enter {
    display: block;
  }
  &.Progressbar-enter-active {
    display: block;
  }
  &.Progressbar-exit {
    display: block;
  }
  &.Progressbar-exit-active {
    display: block;
    opacity: 0;
  }
  &.Progressbar-exit-done {
    display: none;

  }
`;
